// Text the scripts write into the page, in the page's language. Everything
// else lives in index.html and en/index.html.
const COPY = {
  es: {
    marketDate: 'Fecha de mercado',
    priceAxis: 'Precio de AAPL',
    breakeven: 'Equilibrio',
    entryLabel: (price) => `9 ago: ${price}`,
    resultTag: (price, pnl) => `20 sep: ${price} · ${pnl}`,
    hover: (price, pnl) => `AAPL a ${price}: ${pnl}`,
    proYearly: (total) => `Pagando el año: <span class="num">${total}</span>. Prueba de 30 días.`,
    proMonthly: 'Pago mensual. Prueba de 30 días.',
    price: (v) => `${v}<span class="cur">$</span>`,
    company: (name, legal, tax, address) =>
      [`${name} es un producto de ${legal}`, tax && `NIF ${tax}`, address].filter(Boolean).join(', ') + '.',
  },
  en: {
    marketDate: 'Market date',
    priceAxis: 'AAPL price',
    breakeven: 'Breakeven',
    entryLabel: (price) => `Aug 9: ${price}`,
    resultTag: (price, pnl) => `Sep 20: ${price} · ${pnl}`,
    hover: (price, pnl) => `AAPL at ${price}: ${pnl}`,
    proYearly: (total) => `Billed yearly: <span class="num">${total}</span>. 30-day trial.`,
    proMonthly: 'Billed monthly. 30-day trial.',
    price: (v) => `<span class="cur">$</span>${v}`,
    company: (name, legal, tax, address) =>
      [`${name} is a product of ${legal}`, tax && `Tax ID ${tax}`, address].filter(Boolean).join(', ') + '.',
  },
};

export const copy = (lang) => COPY[lang] || COPY.es;
